<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card pt-5 pb-5">
        @for (item of levels; track item.level) {
          <div class="card-body pb-0">
            <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
               [routerLink]="['/program', item.level]">
              <div class="d-flex" style="gap:1rem;">
                <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">stairs</span></i>
                <b class="align-content-center" style="min-width:7rem">&nbsp;ステップ{{ item.level }}</b>
              </div>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
